import OpenAI from "openai";

const openai = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY_SSC,
    dangerouslyAllowBrowser: true
});

const sscAskAnything = async (question, systemPrompt) => {
    const response = await openai.responses.create({
        model: "gpt-4.1",
        instructions: systemPrompt,
        input: question,
        tools: [{
            type: "file_search",
            vector_store_ids: [process.env.REACT_APP_VECTOR_STORE_ID_SSC],
        }],
    });
    if (response?.error) {
        return "I'm sorry, I'm not able to answer that question. Please try again.";
    }
    return response.output_text;
};

export default sscAskAnything;